import { render, staticRenderFns } from "./DoctorStatistics.vue?vue&type=template&id=4a977f2e&"
import script from "./DoctorStatistics.vue?vue&type=script&lang=js&"
export * from "./DoctorStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports